<app-bui-spinner [spinnerType]="'content'"></app-bui-spinner>
